// extracted by mini-css-extract-plugin
export default {"textWrapper":"styles__textWrapper___aF7Ez"};